var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#ffffff"},attrs:{"id":"inspire"}},[_c('Loading',{staticClass:"text-center",attrs:{"title":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }